import { ChargeType } from 'store/modules/ExistingPolicies/types';
import { MetaType } from 'store/modules/Meta/types';
import { formatCurrency, formatPercent } from 'utils';

type prepareChargesTypes = {
  initialValues: Array<ChargeType>;
  chargeTypes: Array<MetaType>;
};

export const prepareCharges = ({
  initialValues,
  chargeTypes
}: prepareChargesTypes) => {
  const acceptedChargeTypes = ['1', '2', '3', '4', '5', '8', '99', '98'];

  const filteredCharges = chargeTypes.filter((charge: MetaType) =>
    acceptedChargeTypes.includes(charge.value)
  );

  const indexOfOther = filteredCharges.findIndex(
    charge => charge.name === 'Other'
  );

  const other = filteredCharges.splice(indexOfOther, 1);

  filteredCharges.splice(filteredCharges.length - 1, 0, other[0]);

  const data = filteredCharges.map((chargeType: MetaType) => {
    const existinValues = initialValues.find((val: ChargeType) => {
      return val.kind === Number(chargeType.value);
    });

    if (existinValues) {
      return {
        name: chargeType.name,
        cash_value: formatCurrency(existinValues.cash_value),
        kind: existinValues.kind,
        percentage_value: formatPercent(existinValues.percentage_value * 100),
        source_value: existinValues.source_value
      };
    }
    return {
      name: chargeType.name,
      cash_value: formatCurrency(0),
      kind: Number(chargeType.value),
      percentage_value: formatPercent(0),
      source_value: 1
    };
  });

  return data;
};
